module.exports = __webpack_public_path__ + "static/install-10c8d23d1c6e904f719d9fa10a937cd0.png";